(ns dre.pages.frontpage.events
  (:require
    [day8.re-frame.tracing :refer-macros [fn-traced]]
    [dre.network :as-alias network]
    [dre.pages.frontpage.keyword-search.events]
    [dre.pages.frontpage.topic-search.events :as topic-events]
    [re-frame.core :as rf]
    [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))


(def db-path [:pages :data :frontpage])


;; -- Events

;; getting stats from app db
(rf/reg-event-fx
  ::init
  [rf/trim-v]
  (fn-traced
    [{db :db} _]
    (when (nil? (:stats-info db))
      {:db (assoc-in db (conj db-path :stats-info :data)  (get-in db [:app :stats]))})))


(rf/reg-event-db
  ::select-search-type
  [(rf/path db-path) rf/trim-v]
  (fn-traced
    [db [search-type]]
    (-> db
        (assoc :search-type search-type)
        (dissoc :topic-search))))

(rf/reg-event-db
 ::clear-state
 [(rf/path db-path)]
 (fn-traced
  [db _]
  (assoc 
   (select-keys db [:stats-info])
   :search-type :topic-search)))

(rf/reg-event-fx
 ::set-topic-search-with-selection
 [(rf/path db-path)]
 (fn-traced
  [{db :db} [_ topic-name]]
  {:db (-> db
           (assoc
            :search-type :topic-search)
           (assoc-in [:topic-search :selected-view] :forms))
   :dispatch [::topic-events/select-topic topic-name]}
  ))

;; -- Subscriptions

(rf/reg-sub
  ::state
  (fn [db _]
    (get-in db db-path)))

(rf/reg-sub
 ::show-stats-footer?
 :<- [::state]
 (fn [state _]
   (let [selected-view (get-in state [:topic-search :selected-view])
         search-type (get state :search-type)]
     (or
      (not= search-type :topic-search)
      (nil? selected-view)
      (= selected-view :topics)))))
